// @flow
import * as ActionTypes from "constants/ActionTypes";

const initialState = {
  isLoading: false,
  serviceError: "",
  serviceCode: 200,
  reqStatus: "",
  page: {
    tryons: [],
    total: 0,
    limit: 20,
    skip: 0,
    hasMore: false,
  },
};

export default function (state: Object = initialState, action: Object) {
  switch (action.type) {
    case ActionTypes.ADMIN_GET_SHOP_VIRTUAL_TRYONS_START:
      return {
        ...state,
        isLoading: true,
        reqStatus: action.type,
        serviceError: "",
      };

    case ActionTypes.ADMIN_GET_SHOP_VIRTUAL_TRYONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: { ...action.error },
      };

    case ActionTypes.ADMIN_GET_SHOP_VIRTUAL_TRYONS_SUCCESS: {
      const payload = action.payload || {};
      if (payload.statusCode === 200 && payload.response) {
        return {
          ...state,
          reqStatus: action.type,
          serviceError: "",
          serviceCode: payload.statusCode,
          isLoading: false,
          page: payload.response,
        };
      }
      return {
        ...state,
        reqStatus: action.type,
        serviceError: "",
        serviceCode: payload.statusCode || 500,
        isLoading: false,
        page: initialState.page,
      };
    }

    case ActionTypes.ADMIN_RESET_SHOP_VIRTUAL_TRYONS:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}

